import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActualizarPreciosRequest, PrecioDetalleDTO } from 'src/app/core/dtos/actualizarPreciosRequest';
import { DetalleDeuda } from 'src/app/core/dtos/detalleDeuda';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { DeudaService } from 'src/app/services/deuda/deuda.service';
@Component({
  selector: 'app-listar-deudas',
  templateUrl: './listar-deudas.component.html',
  styleUrl: './listar-deudas.component.css',
  standalone: true,
  imports: [CommonModule,FormsModule],
})
export class ListarDeudasComponent implements OnInit {

  clienteId: number = 0;
  usuarioId: number = 0;
  nombreProducto: string = '';
  deudas: any[] = [];
  nombreCliente: string = '';
  modoPonerPrecios =false;
  productos: DetalleDeuda[] = [];
  preciosCompletos: boolean = false;
  deudaTotal: number = 0;
  loading = false;
  error = '';
  actualizarPreciosRequest: ActualizarPreciosRequest = { detalles: [] };
  

  constructor(
    private route: ActivatedRoute,
    private clienteService: ClienteService,
    private deudaService: DeudaService,
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  ngOnInit() {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId = +(usuarioId ?? 0);
    this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');
      if (idParam) {
        this.clienteId = +idParam;
        this.cargarDeudas();
      }
    });
  }

  cargarDeudas() {
    this.loading = true;
    this.deudaService.obtenerDeudaPorCliente(this.usuarioId,this.clienteId).subscribe({
      next: (res) => {
        this.deudas = res;
        this.nombreCliente = this.deudas.length > 0 ? this.deudas[0].nombreCliente : '';
        this.deudaTotal = this.deudas.length > 0 ? this.deudas[0].deudaTotal : 0;
        this.loading = false;
      },
      error: () => {
        this.error = 'Error al cargar las deudas';
        this.loading = false;
      }
    });
  }

  
  agregarDeuda(clienteId:number): void {
    this.router.navigate([`cliente/`+clienteId+`/nueva-deuda`]);
  }

  guardarCambios(): void {
    const nuevosProductos = this.productos.filter(p => p.productoId === 0);
    const productosActualizados = this.productos.filter(p => p.productoId !== 0);
    const clienteId = this.route.snapshot.paramMap.get('id');
    // Guardar productos nuevos
    if(clienteId){
      if (nuevosProductos.length > 0) {
        this.clienteService.guardarProductosNuevos(+clienteId,nuevosProductos).subscribe(() => {
          console.log('Productos nuevos guardados.');
        });
      }
  
      // Actualizar productos existentes
      if (productosActualizados.length > 0) {
        this.clienteService.actualizarProductosExistentes(+clienteId, productosActualizados).subscribe(() => {
          console.log('Productos existentes actualizados.');
        });
      }
    }
  }

  cerrarLibreta() {
    const clienteId = this.route.snapshot.paramMap.get('id');
    this.deudaTotal = this.productos.reduce((acc, producto) => acc + producto.precioUnitario, 0);
    if(clienteId){
      this.clienteService.updateDeudaTotal(+clienteId, this.deudaTotal).subscribe(() => {});

    }
    alert('Libreta cerrada con éxito');
    this.router.navigate(['/cliente']);
  }
  volverAtras(): void {
    this.router.navigate(['/cliente']); 
  }

  eliminarProducto(productoId: number): void {
    this.clienteService.eliminarProducto(productoId).subscribe(() => {});
    this.productos.pop();
  }
  pagarDeuda() {
  this.router.navigate(['/crear-pago'], {
    queryParams: {
      clienteId: this.clienteId,
      nombreCliente: this.nombreCliente,
      montoSugerido: this.deudaTotal
      }
    });
  }
  
  activarModoPonerPrecios() {
  this.modoPonerPrecios = true;
}

cancelarModoPrecios() {
  this.modoPonerPrecios = false;
  this.cargarDeudas(); // recarga las deudas para cancelar cambios en inputs
}

hayProductosSinPrecio(): boolean {
  return this.deudas?.some(d =>
    d.detalles?.some((det: DetalleDeuda) => det.precioUnitario == null)
  );
}

guardarPrecios() {
  //const preciosParaActualizar: { detalleDeudaId: number; precioUnitario: number }[] = [];

  this.deudas.forEach(deuda => {
    deuda.detalles.forEach((det: DetalleDeuda) => {
      if (det.precioUnitario !== null && det.precioUnitario !== undefined) {
        this.actualizarPreciosRequest.detalles.push({
          detalleDeudaId: det.detalleId,
          precioUnitario: det.precioUnitario
        });
      }
    });
  });

  if (this.actualizarPreciosRequest.detalles.length === 0) {
    alert('No se ingresaron precios para guardar.');
    return;
  }

  this.deudaService
    .actualizarPrecios(this.clienteId, this.actualizarPreciosRequest)
    .subscribe({
      next: () => {
        this.modoPonerPrecios = false;
        this.cargarDeudas(); // refresca deudas con precios actualizados
      },
      error: () => {
        alert('Error al guardar precios. Intente de nuevo.');
      }
    });
}

recalcularSubtotal(detalle: DetalleDeuda,deuda: any) {
  if (detalle.precioUnitario !== null && detalle.cantidad > 0) {
    detalle.subtotal = detalle.precioUnitario * detalle.cantidad;
  } else {
    detalle.subtotal = 0; // Si no hay precio o cantidad, el subtotal es 0
  }
  // Recalcular subTotalDeuda para esta deuda
  deuda.subTotalDeuda = deuda.detalles.reduce((sum: number, d: DetalleDeuda) => sum + (d.subtotal || 0), 0);

  // Recalcular total de todas las deudas
  this.recalcularDeudaTotal();
}

recalcularDeudaTotal() {
  this.deudaTotal = this.deudas.reduce((total, deuda) => {
    return total + (deuda.subTotalDeuda || 0);
  }, 0);
}

}
